import gql from 'graphql-tag';

export const OpenSpacePermissionsMutation = gql`
	mutation OpenSpacePermissions($spaceKey: String!) {
		openUpSpacePermissions(spaceKey: $spaceKey)
	}
`;
